import { component } from 'picoapp';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { formatMoney } from "@shopify/theme-currency";
import VariantSelector from "./VariantSelector"
import SwatchProducts from './SwatchProducts';

const CrossSell = ({ data }) => {

  const [enabled, setEnabled] = useState(true)
  const [selectedProduct, setSelectedProduct] = useState(data.items.find(p => p.available))
  const [selectedVariant, setSelectedVariant] = useState(selectedProduct.variants.find(v => v.available))
  const [selectedOptions, setSelectedOptions] = useState(selectedProduct.options.reduce((o, key) => ({ ...o, [key]: selectedVariant.options[selectedProduct.options.indexOf(key)] }), {}))

  useEffect(() => {
    setSelectedVariant(selectedProduct.variants.find(v => Object.values(selectedOptions).every(r => v.options.includes(r))))
  }, [selectedOptions])

  const handleProductChange = (e) => {
    const product = data.items.find(p => p.handle == e.target.value)
    const variant = product.variants.find(v => v.available)
    setSelectedProduct(product)
    setSelectedVariant(variant)
    setSelectedOptions(product.options.reduce((o, key) => ({ ...o, [key]: variant.options[product.options.indexOf(key)] }), {}))
  }

  const handleVariantChange = (e) => {
    setSelectedOptions({
      ...selectedOptions,
      [e.target.name]: e.target.value
    })
  }

  return (
    <>
      <label className="cross-sell__toggle">
        <span>{data.title}</span>
        <input type="checkbox" hidden checked={enabled} onChange={() => setEnabled(!enabled)}></input>
        <span className="checkmark"></span>
      </label>
      {enabled &&
        (<div className="cross-sell__main">
          <header className="cross-sell__header">
            <div>
              {
                selectedProduct.title.split('-').length > 1
                  ? (
                    <>
                      <span>{selectedProduct.title.split('-')[1]}</span>
                      <small>{selectedProduct.title.split('-')[0]}</small>
                    </>
                  )
                  : <span>{selectedProduct.title}</span>
              }
            </div>
            <div>{formatMoney(selectedVariant.price)}</div>
          </header>
          <div className='cross-sell__content'>
            {
              selectedVariant.available && <input type="hidden" name="id[]" value={selectedVariant.id}></input>
            }
            <SwatchProducts
              items={data.items}
              selectedProduct={selectedProduct}
              handleChange={handleProductChange}
            />
            {selectedProduct.variants.length > 1 && selectedProduct.options.map((o, opt_idx) =>
              <div className="Product__variantSelector selectorStyle--swatch_and_label" key={`${selectedProduct.handle}-${o}`}>
                <header>{o}</header>
                <div className="variant_options">
                  {[...new Set(selectedProduct.variants.map(v => v[`option${opt_idx + 1}`]))].map((i, idx) =>
                    <VariantSelector
                      selectedProduct={selectedProduct}
                      selectedVariant={selectedVariant}
                      selectedOptions={selectedOptions}
                      handleChange={handleVariantChange}
                      option={o}
                      value={i}
                      index={idx}
                      option_index={opt_idx}
                    />
                  )}
                </div>
              </div>
            )}
          </div >
          {!selectedVariant.available && <div className="message error">The selected option is not available.</div>}
        </div >)

      }
    </>
  )
}

export default component((node, ctx) => {
  if (!customElements.get('cross-sell')) {
    customElements.define(
      'cross-sell',
      class extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          const data = JSON.parse(this.querySelector('script').text)

          const element = <CrossSell ctx={window.theme_app} el={this} data={data} />;
          ReactDOM.render(element, this);
        }
      }
    );
  }
})